<template>
  <div class="learn-details">
    <el-card>
      <h2>学习详情</h2>
      <!-- 搜索栏 -->
      <el-form :inline="true" class="search-bar">
        <!-- 学员姓名下拉框 -->
        <el-form-item>
          <el-select
              v-model="selectedName"
              placeholder="请选择学员"
              clearable
              style="width: 200px"
          >
            <el-option
                v-for="user in users"
                :key="user.value"
                :label="user.label"
                :value="user.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 培训计划下拉框 -->
        <el-form-item>
          <el-select
              v-model="selectedPlan"
              placeholder="请选择培训计划"
              clearable
              style="width: 200px"
          >
            <el-option
                v-for="plan in plans"
                :key="plan.value"
                :label="plan.label"
                :value="plan.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 搜索按钮 -->
        <el-form-item>
          <el-button type="primary" @click="searchLearnDetails">搜索</el-button>
        </el-form-item>
      </el-form>

      <!-- 学习详情表格 -->
      <el-table :data="learnDetails.records" border style="width: 100%">
        <el-table-column prop="planName" label="培训计划名称" width="200"></el-table-column>
        <el-table-column prop="name" label="姓名" width="150"></el-table-column>
        <el-table-column prop="learnedTime" label="学习时长 (秒)" width="150"></el-table-column>
        <el-table-column prop="startDate" label="开始时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.startDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="endDate" label="结束时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.endDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="planwcl" label="完成率 (%)" width="150">
          <template #default="scope">
            {{ scope.row.planwcl.toFixed(1) }}
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页控件 -->
      <el-pagination
          :current-page="pagination.page"
          :page-size="pagination.size"
          :total="learnDetails.total"
          @current-change="handlePageChange"
          layout="prev, pager, next"
      />
    </el-card>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  props: {
    userid: {
      type: Number,
      required: true,
    },
    organizationID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      first: true,
      learnDetails: {
        records: [],
        total: 0,
      }, // 学习详情数据
      selectedName: "", // 选中的学员
      selectedPlan: "", // 选中的培训计划
      pagination: {
        page: 1, // 默认页码为 1
        size: 10,
      },
      users: [], // 学员姓名下拉框数据
      plans: [], // 培训计划下拉框数据
    };
  },
  methods: {
    // 获取学习详情数据
    fetchLearnDetails() {
      const { page, size } = this.pagination;
      const params = {
        userid: this.selectedName, // 学员ID
        planid: this.selectedPlan, // 培训计划ID
        organizationID: this.organizationID, // 固定的组织ID，您可以替换为动态值
        page,
        size,
      };

      console.log("查询参数：", params);

      axios
          .get("/user-watch-history/learnstatus1", { params })
          .then((response) => {
            const fetchedData = response.data.data;
            this.learnDetails = {
              records: fetchedData,
              total: response.data.total,
            };
            if (this.first) {  // 提取下拉框选项
              this.extractUniqueNamesAndPlans(fetchedData);
              this.first = false;
            }
          })
          .catch((error) => {
            console.error("获取学习详情失败：", error);
            this.$message.error("获取学习详情失败！");
          });
    },

    // 点击搜索时将页码归0
    searchLearnDetails() {
      // 设置页码为 1（即第一页）
      this.pagination.page = 1;
      this.fetchLearnDetails();
    },

    // 提取并去重学员姓名和培训计划名称
    extractUniqueNamesAndPlans(data) {
      const uniqueNames = new Set();
      const uniquePlans = new Set();

      data.forEach((item) => {
        uniqueNames.add(item.userId);
        uniquePlans.add(item.planId);
      });

      this.users = Array.from(uniqueNames).map((userId) => {
        const user = data.find((item) => item.userId === userId);
        return { label: user.name, value: userId }; // 显示 name，传递 userId
      });

      this.plans = Array.from(uniquePlans).map((planId) => {
        const plan = data.find((item) => item.planId === planId);
        return { label: plan.planName, value: planId }; // 显示 planName，传递 planId
      });
    },

    // 分页变化时
    handlePageChange(newPage) {
      this.pagination.page = newPage;
      this.fetchLearnDetails();
    },

    // 格式化日期
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, "0")}-${d
          .getDate()
          .toString()
          .padStart(2, "0")}`;
    },
  },

  created() {
    this.fetchLearnDetails();
    console.log(this.userid)
    console.log(this.organizationID)
  },
};
</script>

<style scoped>
.learn-details {
  padding: 20px;
}
.search-bar {
  margin-bottom: 20px;
}
</style>
